import { useCallback, useMemo, useState } from "react";

export const useGuardRequest = ({ policy = {} } = {}) => {
  const [guardRequest, setGuardRequest] = useState(null);

  const runActionWithMiddleware = useCallback(
    async (config) => {
      const {
        actionKey,
        execute,
        details = null,
        onClose,
        requireSecurity = policy[actionKey] === true,
      } = config;

      if (requireSecurity) {
        setGuardRequest({ actionKey, execute, details, onClose });
        return;
      }

      await execute({});
    },
    [policy]
  );

  const handleGuardClose = useCallback(() => {
    if (typeof guardRequest?.onClose === "function") {
      guardRequest.onClose();
    }
    setGuardRequest(null);
  }, [guardRequest]);

  const handleGuardPassed = useCallback(
    async (verificationCode) => {
      if (!guardRequest?.execute) return;
      const execute = guardRequest.execute;
      const actionKey = guardRequest.actionKey || null;
      setGuardRequest(null);
      await execute({ verificationCode, actionKey });
    },
    [guardRequest]
  );

  const guardProps = useMemo(
    () => ({
      open: Boolean(guardRequest),
      onClose: handleGuardClose,
      onPassed: handleGuardPassed,
      details: guardRequest?.details || null,
    }),
    [guardRequest, handleGuardClose, handleGuardPassed]
  );

  return {
    guardRequest,
    guardProps,
    runActionWithMiddleware,
    handleGuardClose,
    handleGuardPassed,
  };
};

